import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95328d9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "expander-label" }
const _hoisted_2 = { class: "count" }
const _hoisted_3 = { class: "children-area" }
const _hoisted_4 = {
  key: 0,
  class: "list-unstyled children-list"
}
const _hoisted_5 = { class: "action-row" }

import { computed } from 'vue'
import { FamilyAndChildren } from '@/rd/ViewFamilyStore'
import { useViewPersonStore } from '@/rd/ViewPersonStore'
import { CompositeId } from '@/rd/CompositeId'
import { canCreateChildRelationship } from './ProfileManager'
import { notImplemented } from '@/util/AppUtil'
import ProfileCard from '@/manage/ProfileCard.vue'
import ProfileRelationshipCard from './ProfileRelationshipCard.vue'
import ExpandableItem from '@/util/ExpandableItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileChildren',
  props: {
    personId: {},
    family: {}
  },
  emits: [
  "addChild",
  "remove",
],
  setup(__props: any, { emit }) {

const props = __props;





const viewPersonStore = useViewPersonStore()

const viewPersonRef = computed(() => viewPersonStore.getLoadedPerson(props.personId))
const isChildRef = computed(() => viewPersonRef.value && props.family.childIds.includes(viewPersonRef.value.id!))
const titleRef = computed(() => isChildRef.value ? "Siblings" : "Children")
const ownerGroupIdRef = computed(() => CompositeId.getGroupId(props.personId))
const hasOwnedFamilyRef = computed(() => props.family.family.matchIds.some(id => CompositeId.hasGroupId(id, ownerGroupIdRef.value!)))
const canAddRef = computed(() => hasOwnedFamilyRef.value && canCreateChildRelationship(undefined, props.family.family))
const canChangeOrderRef = computed(() => props.family.childIds.length > 1)
const addChildTextRef = computed(() => isChildRef.value ? "Add a sibling" : "Add a child")

function changeChildOrder() {
  notImplemented()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ExpandableItem, { class: "profile-children expander" }, {
    item: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createTextVNode(_toDisplayString(titleRef.value) + " ", 1),
        _createElementVNode("span", _hoisted_2, "(" + _toDisplayString(props.family.childIds.length) + ")", 1)
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        (props.family.childIds.length > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.family.childIds, (childId) => {
                return (_openBlock(), _createElementBlock("li", { key: childId }, [
                  (childId == viewPersonRef.value?.id)
                    ? (_openBlock(), _createBlock(ProfileCard, {
                        key: 0,
                        "person-id": childId,
                        "this-profile": ""
                      }, null, 8, ["person-id"]))
                    : (_openBlock(), _createBlock(ProfileRelationshipCard, {
                        key: 1,
                        "rel-person-id": childId
                      }, null, 8, ["rel-person-id"]))
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          (canAddRef.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-inline btn-link action",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('addChild', props.family)))
              }, _toDisplayString(addChildTextRef.value), 1))
            : _createCommentVNode("", true),
          (canChangeOrderRef.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-inline btn-link action",
                onClick: changeChildOrder
              }, " Change order "))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})